module.exports = window.__federationLoadRemote("moduleDirectory");